import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import { ifAuthenticated } from "../access";

import ViberTemplates from "@/pages/Pages/Viber/ViberTemplates.vue";
import ViberTemplate from "@/pages/Pages/Viber/ViberTemplate.vue";
import ViberDetail from "@/pages/Pages/Viber/ViberDetail.vue";
import ViberDetailInfo from "@/pages/Pages/Viber/ViberDetailInfo.vue";
import ViberGroup from "@/pages/Pages/Viber/ViberGroup.vue";
import ViberProviderTariffs from "@/pages/Pages/Viber/ViberProviderTariffs.vue";
import ViberProviderTariff from "@/pages/Pages/Viber/ViberProviderTariff.vue";
import ViberPartnerTariffs from "@/pages/Pages/Viber/ViberPartnerTariffs.vue";
import ViberPartnerTariff from "@/pages/Pages/Viber/ViberPartnerTariff.vue";
import ViberIncomingTariffs from "@/pages/Pages/Viber/ViberIncomingTariffs.vue";
import ViberIncomingTariff from "@/pages/Pages/Viber/ViberIncomingTariff.vue";
import ViberDetailIncoming from "@/pages/Pages/Viber/ViberDetailIncoming.vue";
import ViberDetailIncomingInfo from "@/pages/Pages/Viber/ViberDetailIncomingInfo.vue";
import ViberGroupIncoming from "@/pages/Pages/Viber/ViberGroupIncoming.vue";

const viberMenu = {
  path: "/viber",
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  redirect: "/viber/detail",
  name: "Viber",
  children: [
    {
      path: "templates",
      name: "viber_templates",
      components: { default: ViberTemplates },
      meta: {
        icon: "forum",
        msgKey: 'menu.item.viber.templates'
      }
    },
    {
      path: "templates/new",
      name: "viber_templates_new",
      components: { default: ViberTemplate },
      meta: {
        icon: "forum",
        parentPath: "/viber/templates",
        msgKey: 'menu.item.viber.templates'
      },
    },
    {
      path: "templates/:id",
      name: "viber_templates_edit",
      components: { default: ViberTemplate },
      meta: {
        icon: "forum",
        parentPath: "/viber/templates",
        msgKey: 'menu.item.viber.templates'
      }
    },
    {
      path: "detail",
      name: "viber_detail",
      components: { default: ViberDetail },
      meta: {
        icon: "forum",
        msgKey: 'menu.item.statistics.viber.detail'
      },
    },
    {
      path: "detail/:id",
      name: "viber_detail_info",
      components: { default: ViberDetailInfo },
      meta:{
        icon: "forum",
        parentPath: "/viber/detail",
        msgKey: 'menu.item.statistics.viber.detail'
      }
    },
    {
      path: "group",
      name: "viber_group",
      components: { default: ViberGroup },
      meta: {
        icon: "forum",
        msgKey: 'menu.item.statistics.viber.group'
      },
    },
    {
      path: "partners/tariffs",
      name: "viber_client_tariff",
      components: { default: ViberPartnerTariffs },
      meta: {
        icon: "forum",
        msgKey: 'menu.item.viber.clients.tariff',
      }
    },
    {
      path: "partners/tariffs/new",
      name: "viber_client_tariff_new",
      components: { default: ViberPartnerTariff },
      meta: {
        icon: "forum",
        parentPath: "/viber/partners/tariffs",
        msgKey: 'menu.item.viber.clients.tariff',
      },
    },
    {
      path: "partners/tariffs/:id",
      name: "viber_client_tariff_edit",
      components: { default: ViberPartnerTariff },
      meta: {
        icon: "forum",
        parentPath: "/viber/partners/tariffs",
        msgKey: 'menu.item.viber.clients.tariff',
      }
    },
    {
      path: "service_providers/tariffs",
      name: "viber_provider_tariff",
      components: { default: ViberProviderTariffs },
      meta: {
        icon: "forum",
        msgKey: 'menu.item.viber.provider.tariff',
      }
    },
    {
      path: "service_providers/tariffs/new",
      name: "viber_provider_tariff_new",
      components: { default: ViberProviderTariff },
      meta: {
        icon: "forum",
        parentPath: "/viber/service_providers/tariffs",
        msgKey: 'menu.item.viber.provider.tariff',
      },
    },
    {
      path: "service_providers/tariffs/:id",
      name: "viber_provider_tariff_edit",
      components: { default: ViberProviderTariff },
      meta: {
        icon: "forum",
        parentPath: "/viber/service_providers/tariffs",
        msgKey: 'menu.item.viber.provider.tariff',
      }
    },
    {
      path: "incoming_tariffs",
      name: "viber_incoming_tariffs",
      components: { default: ViberIncomingTariffs },
      meta:{
        icon: "forum",
        msgKey: 'menu.item.viber.mo.routing'
      }
    },
    {
      path: "incoming_tariffs/new",
      name: "viber_incoming_tariffs_new",
      components: { default: ViberIncomingTariff },
      meta: {
        icon: "forum",
        parentPath: "/viber/incoming_tariffs",
        msgKey: 'menu.item.viber.mo.routing'
      },
    },
    {
      path: "incoming_tariffs/:id",
      name: "viber_incoming_tariffs_edit",
      components: { default: ViberIncomingTariff },
      meta:{
        icon: "forum",
        parentPath: "/viber/incoming_tariffs",
        msgKey: 'menu.item.viber.mo.routing'
      }
    },
    {
      path: "detail_incoming",
      name: "viber_detail_incoming",
      components: { default: ViberDetailIncoming },
      meta: {
        icon: "notifications",
        msgKey: 'menu.item.statistics.viber.mo.detail'
      }
    },
    {
      path: "detail_incoming/:id",
      name: "viber_detail_incoming_info",
      components: { default: ViberDetailIncomingInfo },
      meta:{
        icon: "notifications",
        parentPath: "/viber/detail_incoming",
        msgKey: 'menu.item.statistics.viber.mo.detail'
      }
    },
    {
      path: "group_incoming",
      name: "viber_group_incoming",
      components: { default: ViberGroupIncoming },
      meta: {
        icon: "notifications",
        msgKey: 'menu.item.statistics.viber.mo.group'
      }
    },
  ],
};

export default viberMenu;
